import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'
import Icon from 'src/lib/ui/Icon'
import Spinner from 'src/lib/ui/Spinner'
import styles from './LibraryPickRow.module.sass'

const LibraryPickRow = ({
  pick,
  deleting = false,
  canDelete = false,
  onDelete
}) => {
  const handleDelete = !deleting
    ? () => {
        onDelete({
          libraryPickId: pick?.library_pick?.library_pick_id,
          articleId: pick?.id
        })
      }
    : undefined

  return (
    <tr className={styles.row}>
      <td>
        <div className={styles.frequency}>
          {pick?.library_pick?.flagged_date
            ? moment(pick.library_pick.flagged_date).format('MMMM D, YYYY')
            : '—'}
        </div>
      </td>
      <td>
        <div className={styles.label}>
          <Link to={`/story/${pick?.id}`}>{pick?.title || 'Untitled'}</Link>
        </div>
      </td>
      <td>
        {canDelete &&
          (deleting ? (
            <div className={styles.spinner}>
              <Spinner
                fillColor="transparent"
                strokeColor="rgba(213,213,213,1)"
                size={24}
              />
            </div>
          ) : (
            <Icon
              className={styles.icon}
              icon="svg/fw/delete"
              colorTier="secondary"
              onClick={handleDelete}
              button
            />
          ))}
      </td>
    </tr>
  )
}

LibraryPickRow.propTypes = {
  pick: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string,
    library_pick: PropTypes.shape({
      flagged_date: PropTypes.string,
      library_pick_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  }).isRequired,
  deleting: PropTypes.bool,
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func.isRequired
}

export default LibraryPickRow
